import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa93f8ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile__wrapper_main md:!tw-max-h-[unset]" }
const _hoisted_2 = { class: "profile__wrapper" }
const _hoisted_3 = { class: "profile__wrapper-upload" }
const _hoisted_4 = { class: "upload-wrapper" }
const _hoisted_5 = { class: "personal__details__input" }
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = { class: "name_form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Personal Details", -1))
const _hoisted_9 = { class: "form_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Name", -1))
const _hoisted_11 = { class: "form_input" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Last Name", -1))
const _hoisted_13 = { class: "form_input" }
const _hoisted_14 = { class: "gender__field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Gender", -1))
const _hoisted_16 = { class: "contact_form" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title" }, "Contact Details", -1))
const _hoisted_18 = { class: "form_input" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "" }, "Phone Number", -1))
const _hoisted_20 = { class: "contact_input" }
const _hoisted_21 = { class: "form_input not-active" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email Address", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_flag = _resolveComponent("flag")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_file_input, {
            "append-inner-icon": "mdi-image-plus",
            class: _normalizeClass(["upload_file", {
              'no-image-shadow': !$setup.imageUrl && !$setup.userImage,
              'added-img': $setup.imageUrl,
            }]),
            variant: "solo-filled",
            onChange: $setup.onFileChange,
            "onClick:clear": $setup.clearImageUrl
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { icon: "mdi mdi-file-image-box" })
            ]),
            _: 1
          }, 8, ["class", "onChange", "onClick:clear"]),
          _createVNode(_component_v_img, {
            class: "uploaded-img",
            width: 200,
            "aspect-ratio": "16/9",
            cover: "",
            src: $setup.imageUrl ? $setup.imageUrl : $setup.userImage
          }, null, 8, ["src"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_form, {
          ref: "personalDetailsForm",
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
          rules: $setup.personalDetailsFormRules
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_v_text_field, {
                    "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                    density: "compact",
                    variant: "outlined",
                    class: "c-input , rounded-full",
                    autocomplete: "false",
                    placeholder: "First Name",
                    rounded: "",
                    outlined: "false",
                    modelValue: $setup.userForm.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.userForm.firstName) = $event)),
                    rules: $setup.personalDetailsFormRules.firstName
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_v_text_field, {
                    "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                    density: "compact",
                    variant: "outlined",
                    class: "c-input , rounded-full",
                    autocomplete: "false",
                    placeholder: "Last Name",
                    rounded: "",
                    outlined: "false",
                    modelValue: $setup.userForm.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userForm.lastName) = $event)),
                    rules: $setup.personalDetailsFormRules.lastName
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_v_radio_group, {
                      rules: $setup.personalDetailsFormRules.gender,
                      modelValue: $setup.userForm.gender,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.userForm.gender) = $event)),
                      inline: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "Male",
                          value: "male"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "Female",
                          value: "female"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "Other",
                          value: "others"
                        })
                      ]),
                      _: 1
                    }, 8, ["rules", "modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_v_autocomplete, {
                      "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                      modelValue: $setup.userForm.countryCode,
                      "onUpdate:modelValue": [
                        _cache[4] || (_cache[4] = ($event: any) => (($setup.userForm.countryCode) = $event)),
                        $setup.handleCountryCode
                      ],
                      items: $setup.filteredCountries,
                      "item-title": "name",
                      "item-value": "dial_code",
                      density: "compact",
                      variant: "outlined",
                      class: "c-input rounded-full flag-selector",
                      autocomplete: "false",
                      onKeypress: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                      readOnly: true,
                      "menu-props": {
                      maxHeight: '400px',
                      width: '300px',
                    },
                      rounded: "",
                      "close-on-click-outside": false
                    }, {
                      "prepend-item": _withCtx(() => [
                        _createVNode(_component_v_list_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              class: "sticky-search-bar",
                              modelValue: $setup.searchQuery,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.searchQuery) = $event)),
                              label: "Search",
                              "prepend-icon": "mdi-magnify",
                              "single-line": "",
                              "hide-details": "",
                              dense: "",
                              variant: "outlined"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      chip: _withCtx(({ props, item }) => [
                        _createVNode(_component_flag, _mergeProps(props, {
                          style: {"font-size":"50px","width":"100%"},
                          iso: item.raw.code
                        }), null, 16, ["iso"])
                      ]),
                      item: _withCtx(({ props, item }) => [
                        _createVNode(_component_v_list_item, _mergeProps(props, {
                          title: item.raw.name,
                          class: "country__selector"
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_flag, _mergeProps(props, {
                              style: {"font-size":"16px"},
                              iso: item.raw.code
                            }), null, 16, ["iso"])
                          ]),
                          _: 2
                        }, 1040, ["title"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "items", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                      type: "text",
                      density: "compact",
                      placeholder: "Phone Number",
                      variant: "solo",
                      modelValue: $setup.userForm.phoneNumber,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.userForm.phoneNumber) = $event)),
                      rules: $setup.personalDetailsFormRules.phoneNumber,
                      rounded: ""
                    }, null, 8, ["modelValue", "rules"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_v_text_field, {
                    "bg-color": "rgba(12, 15, 74, 0.0509803922)",
                    class: "input_field disabled c-input , rounded-full",
                    density: "compact",
                    variant: "outlined",
                    rounded: "",
                    size: "lg",
                    outlined: "false",
                    placeholder: "Email address",
                    disabled: "",
                    modelValue: $setup.userForm.email,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.userForm.email) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createVNode(_component_v_btn, {
              class: "button button-orange",
              size: "large",
              block: "",
              loading: $setup.loading,
              onClick: $setup.onClickSaveDetails
            }, {
              default: _withCtx(() => [
                _createTextVNode(" SAVE DETAILS ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          _: 1
        }, 8, ["rules"])
      ])
    ])
  ]))
}